export function toSentenceCase(str: string): string {
  if (!str || typeof str !== "string") {
    return ""; // Handle empty or non-string inputs
  }
  // Convert the entire string to lowercase first
  const lowerStr = str.toLowerCase();
  // Capitalize the first character and concatenate with the rest of the string
  return lowerStr.charAt(0).toUpperCase() + lowerStr.slice(1);
}
